import axios from "axios";

export default axios.create({
 baseURL: 'https://api.ptmasayuki.com/public/api/',
 headers: {
  "Content-type": "application/json",
  "Accept": "application/json"
 }
})